<div class="hs-wrapper">

  <!-- ── Header ───────────────────────────────────────────── -->
  <div class="hs-header">
    <span class="hs-title">{{metricDisplayName}}</span>
    <div class="hs-tabs">
      <button
        *ngFor="let tab of data"
        class="hs-tab-btn"
        [class.active]="activeTab?.name === tab.name"
        (click)="switchTab(tab)">
        {{ tab.name }}({{ tab?.children?.length ?? 0 }})
      </button>
    </div>
  </div>

  <!-- ── Accordion list (Critical / Stable) ────────────────── -->
  <div class="hs-body" *ngIf="!isFlakyTab">
    <ng-container *ngIf="displayItems.length > 0; else noDataTpl">
      <div class="hs-accordion-item" *ngFor="let suite of displayItems">

        <!-- Accordion header row -->
        <div class="hs-accordion-header" (click)="toggleNode(suite.name)" (keydown)="toggleNode(suite.name)">
          <span class="hs-suite-name">{{ suite.name }}</span>
          <div class="hs-header-right">
            <img src="assets/images/virtusa-icons/Document_Icon.svg" alt="components" class="hs-count-icon" />
            <span class="hs-count-label">{{ suite.items.length }} Components</span>
            <button class="toggle-button">
              <img *ngIf="isExpanded(suite.name)" src="assets/images/virtusa-icons/remove-outline.svg" alt="add" />
              <img *ngIf="!isExpanded(suite.name)" src="assets/images/virtusa-icons/add-outline.svg" alt="add" />
            </button>
          </div>
        </div>

        <!-- Expanded table -->
        <div class="hs-accordion-body" *ngIf="isExpanded(suite.name)">
          <ng-container *ngIf="suite.items.length > 0; else noRowsTpl">
            <app-zorro-table
              [columns]="currentColumns"
              [data]="suite.tableRows"
              [options]="tableOptions">
            </app-zorro-table>
          </ng-container>
          <ng-template #noRowsTpl>
            <app-no-data></app-no-data>
          </ng-template>
        </div>

      </div>
    </ng-container>

    <ng-template #noDataTpl>
      <app-no-data></app-no-data>
    </ng-template>
  </div>

  <!-- ── Flaky: flat table view (no accordion) ─────────────── -->
  <div class="hs-body hs-accordion-body" *ngIf="isFlakyTab">
    <ng-container *ngIf="displayItems.length > 0 && displayItems[0].tableRows.length > 0; else noFlakyDataTpl">
      <app-zorro-table
        [columns]="currentColumns"
        [data]="displayItems[0].tableRows"
        [options]="tableOptions"
        (handleActions)="onFlakyTableAction($event)">
      </app-zorro-table>
    </ng-container>
    <ng-template #noFlakyDataTpl>
      <app-no-data></app-no-data>
    </ng-template>
  </div>

</div>
